var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data-item"},[_c('div',{staticClass:"data-item_title"},[_vm._v("各时间段销量")]),_c('div',{ref:"chartRef",staticClass:"data-item_content"}),(_vm.emptyFlag)?_c('div',{staticClass:"data-item_empty"},[_vm._v("暂无数据")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }